import {
  Modal,
  ModalFooter,
  ModalBody,
  ModalHeader,
  Button,
  InputGroupAddon,
  InputGroup
} from "reactstrap";
import React, { useState } from "react";
import TreeMenu from "react-simple-tree-menu";
import "./main.scss";
import Icons from "../icons";
import T from "../translate";
export default function InputData({
  context,
  changeInput,
  children,
  inputSize
}) {
  const [input, setInput] = useState({});
  const [open, setOpen] = useState(false);
  const toggle = () => {
    setOpen(!open);
  };

  const onVariableClick = item => {
    if (item.level >= 1) {
      const keys = item.key.split("/"); //solo permite 2 profundidades por ahora
      const inputData =
        item.level >= 2 || item.hasNodes // si es 2 el dato es un modelo o un objeto, ademas se analiza si contiene mas items en su interior
          ? { [keys[1]]: { type: "model", from: keys[0] } }
          : {
              [keys[1]]: {
                type: context.find(o => o.node === keys[0]).exported[keys[1]]
                  .type,
                from: keys[0]
              }
            };
      const data = item.level >= 2 ? `$${keys[1]}.${keys[2]}` : `$${keys[1]}`;
      setInput({ inputData, data });
    }
  };
  return (
    <>
      <InputGroup>
        {children}
        <InputGroupAddon addonType="append">
          <Button
            size={inputSize ? inputSize : ""}
            color="secondary"
            onClick={() => toggle()}
          >
            <Icons
              Config={{ color: "white", size: "1.3em" }}
              Icon="MdSettings"
            />
          </Button>
        </InputGroupAddon>
      </InputGroup>
      <Modal isOpen={open} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <T i18nKey="modalSelectorVariablesTitulo" />
        </ModalHeader>
        <ModalBody>
          <TreeMenu
            data={
              context
                ? context.map(o => ({
                    key: o.node,
                    label: o.node,
                    nodes: Object.entries(o.exported).map(([key, y]) => ({
                      key: key,
                      label: key,
                      nodes: Array.isArray(y)
                        ? y.map(x => ({ key: x.name, label: x.name }))
                        : []
                    }))
                  }))
                : []
            }
            onClickItem={onVariableClick}
          />
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => {
              changeInput(input);
              toggle();
            }}
          >
            <T i18nKey="guardar" />
          </Button>{" "}
          <Button color="secondary" onClick={() => toggle()}>
            <T i18nKey="cancelar" />
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
